import React from "react";
import { HelperText } from "react-native-paper";
import { OutlinedInput } from "./OutlinedInput";
import { useTranslation } from "react-i18next";

import { Field } from "../../config/companies/config";

interface PhoneFieldProps {
  field: Field;
  value: string;
  onChange: (fieldName: string, newValue: any) => void;
  errors?: { [key: string]: string };
}

export const PhoneField = ({
  field,
  value,
  onChange,
  errors = {},
}: PhoneFieldProps) => {
  const { t } = useTranslation();

  const handlePhoneChange = (newValue: string) => {
    onChange(field.name, newValue);
  };

  const label = t(field.label) + (field.required ? "*" : "");

  return (
    <>
      <OutlinedInput
        testID="phone"
        label={label}
        value={value}
        placeholder="+7 (___) ___-__-_"
        onChangeText={handlePhoneChange}
        keyboardType="phone-pad"
      />
      {errors?.[field.name] && (
        <HelperText type="error">{t(errors[field.name])}</HelperText>
      )}
    </>
  );
};
